import MuseumStore from './store'
import { museum as config } from '../config'

export const store = new MuseumStore(config)



// WEBPACK FOOTER //
// ./src/museum/index.js